import * as angular from 'angular';

function сontroller($scope: ng.IScope & any) {
    $scope.viewport = {
        width: $(window).width(),
        height: $(window).height(),
        scrollTop: 0
    };

    $(window).resize(function () {
        $scope.viewport.width = $(window).width();
        $scope.viewport.height = $(window).height();
        $scope.$apply();
    });

    $(window).scroll(function () {
        $scope.viewport.scrollTop = $(document).scrollTop();
        $scope.$apply();
    });
}

angular.module('app.common').controller('viewportController', сontroller);

сontroller.$inject = ['$scope'];



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/controllers/viewport.controller.ts